var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    stroke: "#2B076E",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 42.0002C28.7367 42.0017 28.4758 41.9512 28.2321 41.8517C27.9885 41.7522 27.7668 41.6055 27.5799 41.4202C27.3925 41.2342 27.2437 41.013 27.1422 40.7693C27.0406 40.5256 26.9883 40.2642 26.9883 40.0002C26.9883 39.7362 27.0406 39.4747 27.1422 39.231C27.2437 38.9873 27.3925 38.7661 27.5799 38.5802L34.1999 32.0002L27.8399 25.3802C27.4674 25.0054 27.2584 24.4985 27.2584 23.9702C27.2584 23.4418 27.4674 22.9349 27.8399 22.5602C28.0259 22.3727 28.2471 22.2239 28.4908 22.1224C28.7345 22.0209 28.9959 21.9686 29.2599 21.9686C29.524 21.9686 29.7854 22.0209 30.0291 22.1224C30.2728 22.2239 30.494 22.3727 30.6799 22.5602L38.3999 30.5602C38.7664 30.934 38.9717 31.4367 38.9717 31.9602C38.9717 32.4837 38.7664 32.9863 38.3999 33.3602L30.3999 41.3602C30.2204 41.554 30.0043 41.7104 29.764 41.8203C29.5237 41.9301 29.264 41.9913 28.9999 42.0002Z",
    fill: "#3671E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButton);
export default __webpack_public_path__ + "static/media/arrow-button.6ee5d875492baf6149cedfba81a8fcaf.svg";
export { ForwardRef as ReactComponent };